import { createLocalStorageStateHook } from "use-local-storage-state";

const useToken = createLocalStorageStateHook<string | null>("token", null);

export default useToken;
